import Axios from 'axios'
import { URL } from '../constants/Urls'

export const sendDistributorDetails = async (data) => {
  return await Axios.post(URL.SEND_DISTRIBUTOR_DETAILS, data)
}
